<template>
	<div
		:class="[
			$style['app-notched-outline-idle'],
			{
				[$style['app-notched-outline-idle--notched']]: isFloated,
				[$style['app-notched-outline-idle--hidden']]: isFocused
			}
		]"
	/>
</template>
<script>
export default {
	name: 'NotchedOutlineIdle',
	props: {
		isFloated: {
			type: [Boolean, String],
			required: true
		},
		isFocused: {
			type: [Boolean, String],
			required: true
		}
	}
}
</script>
<style lang="scss" module>
	@property --notch-width {
		syntax: '<length>';
		inherits: true;
		/* stylelint-disable-next-line length-zero-no-unit */
		initial-value: 0px;
	}

	@property --notch-close {
		syntax: '<length>';
		inherits: true;
		/* stylelint-disable-next-line length-zero-no-unit */
		initial-value: 0px;
	}

	.app-notched-outline-idle {
		box-sizing: border-box;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		transition: opacity .15s cubic-bezier(.4,0,.2,1),border-color .15s cubic-bezier(.4,0,.2,1);
		border: 1px solid getColor(border-minor);
		opacity: 1;
		border-radius: 4px;
		pointer-events: none;
		clip-path: polygon(
			0% 0%,
			calc(12px + var(--notch-close, 0px)) 0%,
			calc(12px + var(--notch-close, 0px)) 2px,
			calc(12px + var(--notch-width, 0px) - var(--notch-close, 0px)) 2px,
			calc(12px + var(--notch-width, 0px) - var(--notch-close, 0px)) 0%,
			100% 0%,
			100% 100%,
			0% 100%
		);

		@include dark-mode {
			border-color: getColor(border-darker);
		}

		&:not(&--notched) {
			/* stylelint-disable-next-line declaration-empty-line-before, length-zero-no-unit */
			--notch-close: calc(var(--notch-width, 0px) / 2);

			transition: opacity .15s cubic-bezier(.4,0,.2,1),
						border-color .15s cubic-bezier(.4,0,.2,1),
						--notch-close .15s cubic-bezier(.4,0,.2,1);
		}

		&--hidden {
			opacity: 0;
		}
	}
</style>
